/** @jsx h */
import { h } from 'preact'

const VideoCameraIcon = ({
  width = '18',
  height = '18',
  className = '',
  viewBox = '0 0 24 24',
  stroke = '#222222'
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox={viewBox}
    strokeWidth={1.5}
    stroke={stroke}
    className={className}
    width={width}
    height={height}
    aria-hidden='true'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z'
    />
  </svg>
)

export default VideoCameraIcon
